import React, { Component, createContext } from "react";
import { auth, generateUserDocument } from "../firebase";

// Context
export const UserContext = createContext({ user: null });

// Provider
class UserProvider extends Component {
  state = { user: null };

  componentDidMount = async () => {
    auth.onAuthStateChanged(async (userAuth) => {
      const user = await generateUserDocument(userAuth);
      // console.log("UserProvider -  ");
      // console.log(user);

      if (
        user &&
        (user.roles.includes("admin") || user.roles.includes("auth"))
      ) {
        // const rolemsg = null;
        this.setState({ user });
      } else {
        auth.signOut();
        // user = null;
        const user = null;
        // const rolemsg = 'User is not allowed';
        this.setState({ user });
      }
    });
  };

  render() {
    const { user } = this.state;

    return (
      <UserContext.Provider value={user}>
        {this.props.children}
      </UserContext.Provider>
    );
  }
}

export default UserProvider;
